import React from "react";

const SrlChargerGraphSummary = (props) => {
  const { data, sections } = props;

  return (
    <>
      {data &&
        data.diagnostics &&
        data.diagnostics.records &&
        sections &&
        sections.map((section, sectionIndex) => {
          let sectionCodes = section.codes.map((codeValue, codeIndex) => {
            let record = data.diagnostics?.records?.find((rV) => {
              return rV.code === codeValue;
            });
            return (
              <div
                key={codeIndex}
                className="d-flex justify-content-between border-bottom px-1"
              >
                {/* <td>{v.code}</td> */}
                <div>{record.description ? record.description : codeValue}</div>
                <div>{record.formattedValue ? record.formattedValue : "-"}</div>
              </div>
            );
          });

          return (
            <React.Fragment key={sectionIndex}>
              <div className="d-flex justify-content-between bg-primary bg-opacity-25 px-3">
                <div>
                  <b>{section.title}</b>
                </div>
              </div>
              {sectionCodes}
            </React.Fragment>
          );
        })}
    </>
  );
};

export default SrlChargerGraphSummary;

/*
ble	Bluetooth enabled	Enabled
d	gatewayID	Coupling / GlobalLink
mi	Productid	c021
mn	MachineName	GlobalLink 520
v	Fw Version	v2.06
build	Fw Build date	v2.06-0-g21dffe1, firmware release: 1.20.2.r0, firmware version: v1.20.1.r2-187-ge47ffaec4 on 2020-08-27, modem firmware: 5.1.1.0 [47510] by robot-soft at 2020-01-24 08:44:21
hwr	Hardware revision	PCB revision: A5, chipset: GPy with ESP32
ms	Machine serial number	HQ2125WUFYW
ipr	Remote ip address	3.126.126.6
iccid	SIM card identifier	89882280666026558266
au	Auto update	On
ut	Update to	Official release
us	Update status	Idle
glV	Voltage	13.07 V
glT	Internal temperature	21 °C
glAnt	Antenna Type	External
pcR	Signal RSSI	-103 dB
TO	VRM Log time offset	0 s
sl	VRM Log interval	900 s
mN	Network name	Telefónica Europe (23410)
lt	Latitude	53.20930 LAT
lg	Longitude	-2.34069 LNG
cRelay	Relay 1 state	Open
ScOR	Solar charger off reason	(0)
ScM	Solarcharger model	a054
ScVt	Solar charger version	v1.64
ScSN	Solar charger serial number	HQ2140E2J9C

ScV	Voltage	13.0 V
ScI	Current	1.4 A
ScW	Battery watts	18 W
SLs	Load state	Off
SLI	Load current	0.1 A
ScS	Charge state	Bulk

PVV	PV voltage	20.3 V
PVP	PV power	19 W
ScMm	MPPT State	MPPT active

YT	Yield today	0.01 kWh
MCPT	Maximum charge power today	14 W

YY	Yield yesterday	0.25 kWh
MCPY	Maximum charge power yesterday	37 W

ScERR	Error code	No error

YU	User yield	11.07 kWh
Pt	Solar Yield (delta)	0.01 kWh
Pdc	PV - DC-coupled	19 W

bv	Voltage	12.99 V
bc	Current	1.38 A
bp	Battery Power	18 W
bst	Battery state	idle

diP	Digital input product id	c021
dis	Digital input state	high
dic	Digital input count	0
dit	Digital input type	Generic input
diP	Digital input product id	c021
dis	Digital input state	high
dic	Digital input count	0
dit	Digital input type	Generic input
*/
